import { createObjectFromEntries, createEntries } from './objectHelpers';
import {
  VerificationStep,
  Visit,
  QuestionnaireResponse,
} from '../pages/AuditTrial/components/types';

export type OutputFilters<T = unknown> = [[key: string], T];
export type InputFilters<T = unknown> = { [key: string]: T };

export type DetailFields<T = unknown> = { [key: string]: T };
export type EventNames<T = unknown> = { [key: string]: T[] };

export const formatArray = (filters: InputFilters) => {
  const filtersToEntries = createEntries(filters).reduce((prev, curr) => {
    const [filterKey, filterValue] = curr;
    if ((filterValue as string[]).length) {
      prev.push([[filterKey], (filterValue as string[]).join(',')]);
    }

    return prev;
  }, [] as OutputFilters[]);

  return createObjectFromEntries(filtersToEntries);
};

export const formatAndFilter = (filters: InputFilters) => {
  const filterSelectedFilters = createEntries(filters).filter(
    filter => filter[1]
  );

  return createObjectFromEntries(filterSelectedFilters);
};

export const removeFieldsByEventName = (
  fields:
    | DetailFields
    | VerificationStep
    | Visit
    | QuestionnaireResponse
    | object,
  eventWithUnnecessaryFields: EventNames,
  businessProcess: string
) => {
  const fieldsArray = Object.entries(fields);
  const filteredFields = fieldsArray.filter(field => {
    const fieldToRemove = eventWithUnnecessaryFields[businessProcess];

    if (!fieldToRemove.includes(field[0])) {
      return field;
    }
  });

  return createObjectFromEntries(filteredFields);
};

export const parseJSONOrReturnData = (data: unknown) => {
  if (typeof data !== 'string') {
    return data;
  }

  try {
    const redData = JSON.parse(data as string);
    return redData;
  } catch {
    return data;
  }
};
